import { PRODUCTION_STAFF_APEX } from "@v1/backend/logic/organizations/staff_host";

/** Only these hosts load gtm.js and fbevents.js. Elsewhere (localhost) calls queue in the page, nothing leaves. */
export const LIVE_TRACKING_HOSTNAMES: readonly string[] = [
  PRODUCTION_STAFF_APEX,
  `www.${PRODUCTION_STAFF_APEX}`,
];

export function isLiveTrackingHost(hostname: string): boolean {
  return LIVE_TRACKING_HOSTNAMES.includes(hostname.toLowerCase());
}

export function onLiveTrackingHost(): boolean {
  return (
    typeof window !== "undefined" &&
    isLiveTrackingHost(window.location.hostname)
  );
}
